import React from 'react';
import PropTypes from 'prop-types';
import { List, Image } from '@pella/sash-framework';
import { CTA } from '../../../../../../';
import { isValidArray } from '../../../../../../utilities/validations';

const Tile = ({ data }) => {
	const onTileHover = (e, src) => {
		if (!src) return;
		e.currentTarget.querySelector('img').src = src;
	};

	return (
		<div
			className='group grid grid-cols-[70px_1fr] items-center gap-x-4 overflow-hidden border border-gray-10 bg-white p-2 lg:min-h-[115px] xl:grid-cols-[80px_1fr] xl:grid-rows-[1fr_minmax(min-content,max-content)_min-content_1fr] xl:pr-4'
			onMouseOver={(e) => onTileHover(e, data?.hover?.url)}
			onFocus={(e) => onTileHover(e, data?.hover?.url)}
			onMouseOut={(e) => onTileHover(e, data?.file.url + '?format=pjpg&auto=webp&quality=90')}
			onBlur={(e) => onTileHover(e, data?.file.url + '?format=pjpg&auto=webp&quality=90')}
		>
			<div className='col-start-1 row-start-1 xl:row-span-4'>
				{data?.file?.url && (
					<Image
						src={data.file.url + '?format=pjpg&auto=webp&quality=90'}
						className='h-[70px] w-full border border-gray-3 p-2 xl:h-20'
						objectFit='contain'
						alt=''
					/>
				)}
			</div>

			<div className='col-start-2 row-start-1 xl:row-start-2'>
				{data?.heading && <p className='mb-1 text-base font-bold leading-tight text-gray-70'>{data?.heading}</p>}
				{data?.subheading && (
					<div
						className='max-h-0 text-[10px] font-semibold leading-snug text-gray-60 opacity-0 group-focus-within:max-h-20 group-focus-within:opacity-100 group-hover:max-h-20 group-hover:opacity-100 motion-safe:transition-all motion-safe:duration-500'
						dangerouslySetInnerHTML={{ __html: data?.subheading }}
					/>
				)}
			</div>

			{isValidArray(data?.cta) && (
				<List
					bullets='none'
					className='col-start-1 row-start-3 -mx-0.5 mt-2 flex max-h-0 flex-row flex-wrap opacity-0 group-focus-within:max-h-20 group-focus-within:opacity-100 group-hover:max-h-20 group-hover:opacity-100 motion-safe:transition-all motion-safe:duration-500 max-xl:col-span-2 xl:col-start-2'
				>
					{data?.cta.map((cta, index) => {
						return (
							<li
								key={index}
								className='flex-1 px-0.5'
							>
								<CTA
									data={cta}
									className='border-2 !py-3 !leading-none xl:!px-0 xl:!py-1 xl:!text-xs'
									wide
								/>
							</li>
						);
					})}
				</List>
			)}
		</div>
	);
};

Tile.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Tile;
